import Viewer from 'marzipano/src/Viewer';
import ImageUrlSource from 'marzipano/src/sources/ImageUrl';
import FlatGeometry from 'marzipano/src/geometries/Flat';
import FlatView from 'marzipano/src/views/Flat';
import compose from 'marzipano/src/util/compose';
import ElementPressControlMethod from 'marzipano/src/controls/ElementPress';

for (const preview of document.querySelectorAll('.r-panorama--preview')) {
    preview.addEventListener('click', function() {
        const contents = this.parentNode.querySelector('.r-panorama--contents'); // eslint-disable-line no-invalid-this
        if (contents.classList) {
            contents.classList.remove('hidden');
        } else {
            // IE9-
            const classes = contents.className.split(' ');
            const classIndex = classes.indexOf('hidden');

            if (classIndex >= 0) {
                classes.splice(classIndex, 1);
            }
            contents.className = classes.join(' ');
        }
    });
}

function tileUrl(imageSource, z, x, y) {
    return `${imageSource}/l${z}/${y}/l${z}_${y}_${x}.jpg`;
}

for (const panorama of document.querySelectorAll('.r-panorama--image')) {
    const imageSource = panorama.dataset.source;
    const imageWidth = panorama.dataset.width;
    const imageHeight = panorama.dataset.height;
    const imageSizes = JSON.parse(atob(panorama.dataset.sizes));
    delete panorama.dataset.source;
    delete panorama.dataset.width;
    delete panorama.dataset.height;
    delete panorama.dataset.sizes;
    const panoramaContents = panorama.parentNode;

    const viewer = new Viewer(panorama, {
        controls: {
            mouseViewMode: 'drag',
        },
    });

    const source = new ImageUrlSource(function(tile) {
        return { url: tileUrl(imageSource, tile.z + 1, tile.x + 1, tile.y + 1) };
    });

    const geometry = new FlatGeometry(imageSizes);

    const limiter = compose(
        FlatView.limit.resolution(imageWidth),
        FlatView.limit.letterbox()
    );
    const view = new FlatView({ mediaAspectRatio: imageWidth / imageHeight}, limiter);

    const scene = viewer.createScene({
        source: source,
        geometry: geometry,
        view: view,
        pinFirstLevel: true,
    });
    scene.switchTo();

    const viewInElement = panoramaContents.querySelector('.r-panorama--zoom-in');
    const viewOutElement = panoramaContents.querySelector('.r-panorama--zoom-out');

    const velocity = .7;
    const friction = 3;

    const controls = viewer.controls();
    controls.registerMethod('inElement', new ElementPressControlMethod(viewInElement, 'zoom', -velocity, friction), true);
    controls.registerMethod('outElement', new ElementPressControlMethod(viewOutElement, 'zoom', velocity, friction), true);

    const closeElement = panoramaContents.querySelector('.r-panorama--close');

    closeElement.addEventListener('click', function() {
        if (panoramaContents.classList) {
            panoramaContents.classList.add('hidden');
        } else {
            // IE9-
            const classes = panoramaContents.className.split(' ');
            const classIndex = classes.indexOf('hidden');

            if (classIndex < 0) {
                classes.push('hidden');
            }
            panoramaContents.className = classes.join(' ');
        }
    });
}
